import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

interface Props {
  lables: any;
  top: any;
}

function ProductLabels({ lables, top = 1 }: Props) {
  const delay = 5000;
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    setTimeout(
      () =>
        setIndex(prevIndex =>
          prevIndex === lables.length - 1 ? 0 : prevIndex + 1,
        ),
      delay,
    );
  }, [index]);
  const firstLabel = lables[0];
  if (firstLabel) {
    return (
      <Wrapper top={top}>
        <LabelsSlider index={-index}>
          <Label
            bgColor={firstLabel.bg_color}
            textColor={firstLabel.text_color}
          >
            {firstLabel.text}
          </Label>
          {/* {lables.map((lable, i) => {
            if (!lable) {
              return null;
            }
            return (
              <Label
                bgColor={lable.bg_color}
                textColor={lable.text_color}
                key={i}
              >
                {lable.text}
              </Label>
            );
          })} */}
        </LabelsSlider>
      </Wrapper>
    );
  } else {
    return null;
  }
}

const Label = styled.div<{ bgColor: string; textColor: string }>`
  color: ${({ textColor }) => textColor};
  background-color: ${({ bgColor }) => bgColor};
  padding: ${rem(4)};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 500;
  transition: ease 600ms;
  text-align: center;
  border-radius: 50%;
  height: ${rem(80)};
  width: ${rem(80)};
  display: flex;
  align-items: center;
`;

const LabelsSlider = styled.div<{ index }>`
  //transition: ease 1000ms;
  //transform: translate3d(0, ${({ index }) => index * 26}px, 0);
`;

const Wrapper = styled.div<{ top: number }>`
  margin: 0 auto;
  position: absolute;
  border-radius: 50%;
  top: ${({ top }) => rem(top)};
  right: ${rem(16)};
`;

export default ProductLabels;
